import { Badge } from '@shared/components';
import type { GroupPermissionTriple } from '../types/security-admin.types';

interface Props {
  permissions: GroupPermissionTriple | undefined;
}

export function GroupPermissionBadges({ permissions }: Props) {
  if (!permissions) {
    return <span className="text-mp-muted text-xs">No permissions</span>;
  }
  return (
    <div className="flex gap-1">
      {permissions.can_quote && <Badge variant="info">Quote</Badge>}
      {permissions.can_invoice && <Badge variant="success">Invoice</Badge>}
      {permissions.can_sell && <Badge variant="warning">Sell</Badge>}
    </div>
  );
}
